import axios, { AxiosRequestConfig } from "axios";

class FetchService {
  cacheTime = 600
  cache = new Map()
  token = ''

  private fetchFromCache(cacheName: string) {
    if (this.cache.has(cacheName)) {
      const item = this.cache.get(cacheName)
      if (Date.now() - item.timestamp < this.cacheTime) {
        return item.data
      }
    }
    return null
  }

  private writeToCache(cacheName: string, data: object) {
    if (this.cache.has(cacheName)) {
      this.cache.delete(cacheName)
    }
    this.cache.set(cacheName, {
      timestamp: Date.now(),
      data: data
    })
  }

  private setToken(token: string) {
    this.token = token
    window.sessionStorage.setItem('token', token)
  }

  private getToken() {
    try {
      return window.sessionStorage.getItem('token')
    } catch {  
      return this.token
    }
  }

  async get(url: string) {
    const cacheName = 'get:' + url
    
    const cached = this.fetchFromCache(cacheName)
    if (cached) {
      return cached
    }
    // debugging
    // return []
    let options: AxiosRequestConfig = {}
    if (this.getToken()) {
      options.headers = {
        'X-AUTH-TOKEN': this.getToken(),
      }
    }
      
    try {
      const response = await axios.get(url, options)
      if (response.status === 401) {
        this.setToken('')
        window.location.href = '/login'
        return null
      }
      this.writeToCache(cacheName, response.data)
      return response.data
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  async post(url: string, postData: object) {
    const cacheName = 'get:' + url
    
    const cached = this.fetchFromCache(cacheName)
    if (cached) {
      return cached
    }
    // debugging
    // return []
    let options: AxiosRequestConfig = {}
    if (this.getToken()) {
      options.headers = {
        'X-AUTH-TOKEN': this.getToken(),
      }
    }
      
    try {
      const response = await axios.post(url, postData, options)
      if (response.status === 401) {
        this.setToken('')
        window.location.href = '/login'
        return null
      }
      this.writeToCache(cacheName, response.data)
      return response.data
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  async login(email: string, password: string): Promise<string> {
    try {
      const response = await axios.post('/api/login', {
        email,
        password,
      });

      // Das Token aus der Antwort extrahieren
      this.setToken(response.data.token)
      return '';
    } catch (error) {
      // Fehlerbehandlung (z.B. falsche Credentials)
      if (axios.isAxiosError(error) && error.response) {
        console.error('Login failed:', error.response.data);
        return 'Login Fehlgeschlagen';
      } else {
        console.error('Login error:', error);
        return 'Login Fehler';
      }
    }
  }

  isLoggedIn() {
    return this.getToken() !== ''
  }

  logout() {
    this.setToken('')
  }
}

const fetchService = new FetchService();
export default fetchService
